import Link from 'next/link'
import { useState } from 'react'
import Sidebar from 'ui/components/Sidebar/'
import { Logo } from 'ui/components/Sidebar/components'
import Icon from '../Icon'
import { HeaderBar, HeaderBurger } from './styled'

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false)

  return (
    <>
      <HeaderBar>
        <Link href="/">
          <a>
            <Logo />
          </a>
        </Link>
        <HeaderBurger onClick={() => setMenuOpened(!menuOpened)}>
          {menuOpened ? (
            <Icon name="menu-close" size="40" />
          ) : (
            <Icon name="burger" size="40" />
          )}
        </HeaderBurger>
      </HeaderBar>
      <Sidebar opened={menuOpened} setMenuOpened={setMenuOpened} />
    </>
  )
}

export default Header
